import * as React from 'react';

import * as styles from './styles/tabletAndDesktopLayout.css';
import { GroupsSection } from '../../GroupsSection';
import { SubscriptionsSectionContainer } from '../../SubscriptionsSection';

export function TabletAndDesktopLayout() {
  return (
    <div className={styles['layout']}>
      <GroupsSection isActiveScreen key="GroupsSection" />
      <SubscriptionsSectionContainer isActiveScreen key="SubscriptionsSection" />
    </div>
  );
}
